import { ILoginParams } from "types/login";
import { sendPost } from "./axios";

export const login = (params: ILoginParams) => sendPost("/login", params);
